import { useSyncExternalStore } from 'react';

type DeviceType = 'mobile' | 'desktop';

const MOBILE_MEDIA_QUERY = '(max-width: 991px)';

const getDeviceSnapshot = (): DeviceType =>
	window.matchMedia(MOBILE_MEDIA_QUERY).matches ? 'mobile' : 'desktop';

const getServerDeviceSnapshot = (): DeviceType => 'desktop';

const subscribe = (onStoreChange: () => void) => {
	const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
	mql.addEventListener('change', onStoreChange);

	return () => mql.removeEventListener('change', onStoreChange);
};

const useDevice = (): DeviceType =>
	useSyncExternalStore(subscribe, getDeviceSnapshot, getServerDeviceSnapshot);

export default useDevice;
